import {Routes} from '@angular/router';
import {AlertsComponent} from './alerts.component';

export const alertsRouting: Routes = [
  {
    path: '',
    component: AlertsComponent,
  },
];
